class SwymWishlistButton extends HTMLElement {
  constructor() {
    super();
    this.elements = {};
    this.initializeElements();
  }

  connectedCallback() {
    this.setupWishlistFunctions();
  }

  static observedAttributes = ['data-variant-id'];

  initializeElements() {
    const wishlistButton = this.querySelector('#swymcs-wishlist-button');
    if (wishlistButton) {
      this.elements.wishlistButton = wishlistButton;
      
      // Add click event listener
      wishlistButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleWishlistClick();
      });
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updateButtonState();
  }

  setupWishlistFunctions() {
    // Initialize SwymCallbacks if not already done
    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    
    // Add our init function to SwymCallbacks
    window.swymcsWishlistFunctions = {
      refreshList: this.refreshList.bind(this),
      updateButtonState: this.updateButtonState.bind(this),
      updateButtonWishlistState: this.updateButtonWishlistState.bind(this),
      addToWishlist: this.addToWishlist.bind(this),
      removeFromWishlist: this.removeFromWishlist.bind(this),
      addSwymEventListener: this.addSwymEventListener.bind(this)
    };

    if (!window.swymcsWishlistFunctions.init) {
      window.swymcsWishlistFunctions.init = this.init.bind(this);
      window.swymcsWishlistFunctions.fetchList = this.fetchList.bind(this);
    }

    window.SwymCallbacks.push(window.swymcsWishlistFunctions.init);
  }

  async init(swat) {
    let lists = await this.fetchList(swat);
    if (!window.swymSelectedListId) {
      this.createList(swat);
    }
    this.addSwymEventListener(swat);
  }

  async fetchList(swat) {
    return new Promise((resolve, reject) => {
      const onSuccess = (lists) => {
        window.swymWishLists = lists;
        window.swymSelectedListId = lists && lists[0] && lists[0].lid;

        resolve(lists);
        this.updateButtonState();
      };

      const onError = (error) => {
        reject(error);
      };

      if (!window.swymWishLists) {
        swat.fetchLists({
          callbackFn: onSuccess,
          errorFn: onError
        });
      } else {
        resolve(window.swymWishLists);
      }
    });
  }

  createList(swat) {
    let listConfig = { "lname": "My Wishlist" };
    
    let onSuccess = function({lid}) { 
      window.swymSelectedListId = lid;
    }
    
    let onError = function(error) {
      console.log("Error while creating a List", error);
    }
    
    swat.createList(listConfig, onSuccess, onError);
  }

  async refreshList(swat) {
    window.swymWishLists = null;
    await this.fetchList(swat);
  }

  addToWishlist(swat, product) {
    let onSuccess = async function(addedListItem) {
      // Dispatch a custom event for cart update
      const productCount = window.swymWishLists[0].listcontents.length;
      const cartUpdateEvent = new CustomEvent('wishlist:itemAdded', {
        detail: {
          productCount: productCount
        }
      });
      document.dispatchEvent(cartUpdateEvent);
      // Refresh the list to update button state
      if (window.swymcsWishlistFunctions) {
        await window.swymcsWishlistFunctions.refreshList(swat);
      }
    }
    
    let onError = function(error) {
      swat.ui.showErrorNotification({ message: "Error Adding Product to Wishlist" });
    }

    let lid = window.swymSelectedListId;
    swat.addToList(lid, product, onSuccess, onError);
  }

  removeFromWishlist(swat, product) {
    let onSuccess = async function(deletedProduct) {
      // Dispatch a custom event for cart update 
      const productCount = window.swymWishLists[0].listcontents.length;
      const cartUpdateEvent = new CustomEvent('wishlist:itemRemoved', {
        detail: {
          productCount: productCount
        }
      });
      document.dispatchEvent(cartUpdateEvent);
      // Refresh the list to update button state
      if (window.swymcsWishlistFunctions) {
        await window.swymcsWishlistFunctions.refreshList(swat);
      }
    }
      
    let lid = window.swymSelectedListId;
    swat.deleteFromList(lid, product, onSuccess);
  }

  updateButtonState() {
    if (!this.elements.wishlistButton) return;
    
    const { productId, variantId } = this.dataset;
    let isWishlisted = false;

    if (window.swymWishLists) {
      window.swymWishLists.forEach(list => {
        list.listcontents.forEach(item => {
          if (item.empi == productId && item.epi == variantId) {
            isWishlisted = true;
          }
        });
      });
      this.updateButtonWishlistState(isWishlisted);
    }
  }

  updateButtonWishlistState(isWishlisted) {
    if (!this.elements.wishlistButton) return;
    
    if (isWishlisted) {
      this.elements.wishlistButton.classList.add('swym-added-custom');
    } else {
      this.elements.wishlistButton.classList.remove('swym-added-custom');
      this.elements.wishlistButton.classList.remove('disabled');
      this.elements.wishlistButton.removeAttribute('disabled');
    }
  }

  addSwymEventListener(swat) {
    // Listen for Swym events to update button state
    if (window.SwymEventBroker) {
      window.SwymEventBroker.subscribe('swym:addToList', () => {
        this.updateButtonState();
      });
      
      window.SwymEventBroker.subscribe('swym:deleteFromList', () => {
        this.updateButtonState();
      });
    }
  }

  handleWishlistClick() {
    const button = this.elements.wishlistButton;
    const productId = this.dataset.productId;
    const variantId = this.dataset.variantId;
    const productUrl = this.dataset.productUrl;
    
    // Simple product data
    const product = {
      empi: productId,
      epi: variantId,
      du: productUrl
    };

    // Check if product is already in wishlist
    const isWishlisted = button.classList.contains('swym-added-custom');
    
    if (window._swat) {
      if (isWishlisted) {
        this.removeFromWishlist(window._swat, product);
      } else {
        this.addToWishlist(window._swat, product);
      }
    }
  }
}

customElements.define('swym-wishlist-button', SwymWishlistButton);